import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect } from "react-router-dom";
import myToast from "../Utils/MyToast";
import MdlSectionShift from "../dialog/MdlSectionShift";
import BackButton from "../ChildComponent/BackButton";

const SectionShift = (props) => {
  const [loggedIn, setLoggedIn] = useState(() => !!localStorage.getItem("token"));
  const [loading, setLoading] = useState(false);
  const [loadingStudent, setLoadingStudent] = useState(false);

  const [SESSION_ID, setSESSION_ID] = useState("");
  const [SESSION_NAME, setSessionName] = useState("");
  const [CLASS_ID, setCLASS_ID] = useState("");
  const [SECTION_ID, setSECTION_ID] = useState("");
  const [StudentList, setStudentList] = useState([]);
  const [mSelectedStudent, setMSelectedStudent] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [sectionList, setSectionList] = useState([]);
  const params = (props && props.match && props.match.params) ? props.match.params : {};

  useEffect(() => {
    window.scrollTo(0, 0);
    const mSession = SessionManager.getCurrentSession();
    if (mSession && mSession.length) {
      setSESSION_ID(mSession[0].session_id);
      setSessionName(mSession[0].session_name);
    }
    // Prefill from URL params if provided: /AdminMain/SectionShift/:class_id/:section_id/:session_id?
    if (params?.class_id) setCLASS_ID(params.class_id);
    if (params?.section_id) setSECTION_ID(params.section_id);
    if (params?.session_id) setSESSION_ID(params.session_id);
  }, []);

  useEffect(() => {
    if (CLASS_ID && SESSION_ID && SECTION_ID) getStudentList();
  }, [CLASS_ID, SECTION_ID, SESSION_ID]);

  const getSectionList = useCallback(async () => {
    try {
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const FUNCTION_NAME = "getClassWithStudentCount.php";
      const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;
      const { data } = await axios.get(URL, { params: { school_code: SCHOOL_CODE, session_id: SESSION_ID } });
      if (data.api_status === "OK") {
        setSectionList(Array.isArray(data.data.all_section) ? data.data.all_section : []);
      }
    } catch (e) {
      console.error("Error loading section list", e);
    }
  }, [SESSION_ID]);

  useEffect(() => {
    if (SESSION_ID) getSectionList();
  }, [SESSION_ID, getSectionList]);

  const getStudentList = useCallback(() => {
    setLoadingStudent(true);
    setStudentList([]);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getCurrentStudent.php";
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;
    const params = { school_code: SCHOOL_CODE, class_id: CLASS_ID, section_id: SECTION_ID, session_id: SESSION_ID };
    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setLoadingStudent(false);
        if (response.api_status === "OK") {
          setStudentList(response.data || []);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoadingStudent(false);
        console.error("Error fetching student list:", error);
      });
  }, [CLASS_ID, SECTION_ID, SESSION_ID]);


  const getStudentIdsJson = useCallback(
    () =>
      JSON.stringify(
        mSelectedStudent.map(({ student_enrollment_no, student_roll_no }) => ({
          student_enrollment_no,
          student_roll_no,
        }))
      ),
    [mSelectedStudent]
  );

  const HandleOpenDialog = useCallback(() => {
    if (mSelectedStudent.length === 0) {
      myToast.notify_error("Select Student !!!");
    } else {
      setIsOpen(true);
    }
  }, [mSelectedStudent.length]);

  const HandleClose = useCallback(() => setIsOpen(false), []);

  const HandleShiftToSection = useCallback(
    async (new_section_id) => {
      setIsOpen(false);
      setLoading(true);
      try {
        const SCHOOL_CODE = SessionManager.getSchoolCode();
        const mStaffData = SessionManager.getStaffDetails();
        const STAFF_ID = mStaffData?.staff_id || "";
        const FUNCTION_NAME = "updateStudentSectionShift.php";
        const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;
        const params = {
          staff_id: STAFF_ID,
          existing_section_id: SECTION_ID,
          new_section_id,
          class_id: CLASS_ID,
          student_list: getStudentIdsJson(),
          school_code: SCHOOL_CODE,
        };
        const { data } = await axios.get(URL, { params });
        setLoading(false);
        if (data.api_status === "OK") {
          myToast.notify_success("Section shift successful");
          setMSelectedStudent([]);
          getStudentList();
        } else {
          myToast.notify_warning(data.api_remark || "Failed to shift section");
        }
      } catch (e) {
        setLoading(false);
        console.error("Error shifting section", e);
        myToast.notify_error("Something went wrong while shifting section");
      }
    },
    [CLASS_ID, SECTION_ID, getStudentIdsJson, getStudentList]
  );

  const onToggleStudent = (e, index) => {
    const isChecked = e.target.checked;
    const student = StudentList[index];
    setMSelectedStudent((prev) => {
      if (isChecked) {
        if (!prev.some((s) => s.student_enrollment_no === student.student_enrollment_no)) {
          return [...prev, student];
        }
        return prev;
      } else {
        return prev.filter((s) => s.student_enrollment_no !== student.student_enrollment_no);
      }
    });
  };

  const allSelected = useMemo(() => StudentList.length > 0 && mSelectedStudent.length === StudentList.length, [StudentList, mSelectedStudent]);
  const toggleSelectAll = useCallback((e) => {
    const checked = e.target.checked;
    if (checked) {
      setMSelectedStudent(StudentList);
    } else {
      setMSelectedStudent([]);
    }
  }, [StudentList]);

  if (!loggedIn) return <Redirect to="/Login" />;
  if (loading) return <MyLoader />;

  return (
    <div className="content">
      <div className="content-header d-flex justify-content-between align-items-center">
        <div className="leftside-content-header d-flex align-items-center">
          <BackButton></BackButton>
          <ul className="breadcrumbs mb-0">
            <li>
              <a href="#">Section Shift</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow" style={{ "--mMargin": "50px" }}>
        <div className="row">
          <div className="col-sm-12 col-md-12">
            <div className="bg_card_primary" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 10px' }}>
              <h3 className="en-adhar text-white mb-0">Selected Students: {mSelectedStudent.length}</h3>
              <label className="text-white" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                <input type="checkbox" checked={allSelected} onChange={toggleSelectAll} />
                <span>Select All</span>
              </label>
            </div>
          </div>
        </div>

        <div className="row">
          {loadingStudent ? (
            <div>
              <MyLoader />
            </div>
          ) : (
            StudentList &&
            StudentList.map((item, index) => (
              <div className="col-sm-6" key={item.id} style={{ marginBottom: "10px" }}>
                <div className="row bg_card_blue_outline" style={{ padding: "5px" }}>
                  <div className="col-sm-2 bg_card_blue" style={{ padding: "0px", height: "60px" }}>
                    <div className="gravity_center" style={{ padding: "0px", margin: "2px", height: "50px", width: "50px" }}>
                      <div className="circular_image">
                        <img src={item.student_img_path} alt="" />
                        <p className="student_id gravity_center">
                          <small>{item.student_enrollment_no}</small>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6" style={{ padding: "2px", height: "60px" }}>
                    <h6 className="mb-0 black">{item.stu_name}</h6>
                    <p className="mb-0 black7">
                      Father: <span className="nowrap">{item.father_name}</span>
                    </p>
                    <div className="gravity_center_row">
                      <h6 className="black7">
                        <span>
                          {item.section_id === "No" ? `Class ${item.class_name}` : `Class ${item.class_name}:${item.section_name}`}
                        </span>
                      </h6>
                    </div>
                  </div>
                  <div className="col-sm-4 padding_0 gravity_center" style={{ height: "60px" }}>
                    <div className="text-center bg_card_blue_outline width_fill_parent height_match_parent" style={{ margin: "2px" }}>
                      <p className="mb-0 black7">Roll No.{item.student_roll_no}</p>
                      <p>
                        <div className="st-list-roll-n" style={{ background: "#fff", width: "35px", height: "35px", padding: "2px", borderRadius: "50%", margin: "2px auto", fontSize: "20px" }}>
                          <input
                            type="checkbox"
                            className="ch-in"
                            onChange={(e) => onToggleStudent(e, index)}
                            checked={mSelectedStudent.some((s) => s.student_enrollment_no === item.student_enrollment_no)}
                          />
                        </div>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="row">
          <div className="col-sm-12 col-md-12">
            <button className="btn btn-success match_parent" onClick={HandleOpenDialog} style={{ fontSize: "22px", marginBottom: "0px" }}>
              Shift Section
            </button>
          </div>
        </div>

        {isOpen && (
          <MdlSectionShift
            class_id={CLASS_ID}
            current_section_id={SECTION_ID}
            session_id={SESSION_ID}
            sectionList={sectionList}
            actionClose={HandleClose}
            actionSelectSection={HandleShiftToSection}
          />
        )}
      </div>
    </div>
  );
};

export default SectionShift;


